/* Original name @uswitch/trustyle.embedded-video */

import * as React from 'react'
import { AccordionPanel, AccordionButton, Accordion, AccordionItem } from '@uswitch/spark.accordion'

const vimeoParameters = '?autoplay=1&loop=1&muted=1&background=1'
const youtubeParameters = '?autoplay=1&loop=1&mute=1&controls=0&modestbranding=1&rel=0'

const youtubeVideoId = url => {
  return url.slice(-11)
}

const constructUrl = (source, autoPlay) => {
  if (source.includes('youtube')) {
    return autoPlay
      ? `${source}${youtubeParameters}&playlist=${youtubeVideoId(source)}`
      : `${source}?rel=0`
  } else {
    return autoPlay ? source + vimeoParameters : source
  }
}

const EmbeddedVideo = ({
  source,
  allowFullScreen = true,
  hasAccordion = true,
  accordionTitle = '',
  accordionContent = '',
  autoPlay = false,
  className,
}) => (
  <div className={className}>
    <div
      sx={{
        position: 'relative',
        width: '100%',
        height: '0',
        paddingBottom: '56.25%',
        overflow: 'hidden',
        maxWidth: '100%',
      }}
    >
      <iframe
        sx={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
        }}
        src={constructUrl(source, autoPlay)}
        frameBorder='0'
        allowFullScreen={allowFullScreen}
        allow='autoplay'
        title='Video'
      />
    </div>
    <If condition={hasAccordion}>
      <Accordion expandSingleSection={true}>
        <AccordionItem open={true}>
          <AccordionButton>{accordionTitle}</AccordionButton>
          <AccordionPanel>{accordionContent}</AccordionPanel>
        </AccordionItem>
      </Accordion>
    </If>
  </div>
)

export default EmbeddedVideo
